// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1S1iu","type":"styles_type__a-ldz","choices":"styles_choices__1Masb"};